import { RetroButton } from '@/components/retro/RetroButton'
import { ArrowRight, Star } from 'lucide-react'

interface HomeSectionProps {
  onNavigate: (section: string) => void
}

export const HomeSection = ({ onNavigate }: HomeSectionProps) => {
  return (
    <div className="flex flex-col h-full animate-fade-in">
      <div className="text-center mb-6 mt-4">
        <h1 className="text-3xl md:text-5xl font-serif font-bold text-[#8B0000] drop-shadow-sm tracking-tight">
          Bem-vindo ao Banco da Sucata
        </h1>
      </div>

      <div className="w-full bg-white border border-gray-500 mb-6 font-mono text-sm px-3 py-1 flex items-center shadow-inner justify-between">
        <div className="flex items-center">
          <span className="text-gray-500 mr-2 font-bold">CONEXÃO:</span>
          <span className="text-black animate-pulse">ESTABELECIDA</span>
        </div>
        <span className="text-gray-400 text-xs">www.bancodasucata.com.br</span>
      </div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6 pb-6">
        {/* Banner 1: Comparison */}
        <div className="relative bg-gradient-to-br from-gray-700 to-gray-900 text-white p-6 retro-bevel-outset flex flex-col justify-between overflow-hidden group shadow-xl">
          <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-8 py-1 rotate-45 translate-x-8 translate-y-4 shadow-md z-10 border border-white">
            Confira Agora!
          </div>
          <div>
            <h2 className="text-2xl font-bold font-serif mb-3 border-b border-white/30 pb-2">
              Sucata vs. Lixo
            </h2>
            <p className="font-serif text-lg leading-snug text-gray-200">
              Descubra por que seus resíduos metálicos valem dinheiro.
              Transforme custo em receita hoje mesmo.
            </p>
          </div>
          <div className="mt-6 flex justify-end">
            <RetroButton variant="flat-3d" onClick={() => onNavigate('sobre')}>
              Entenda <ArrowRight className="w-4 h-4 ml-1 inline" />
            </RetroButton>
          </div>
        </div>

        {/* Banner 2: Promo */}
        <div className="relative bg-[#FFFF00] p-6 retro-bevel-outset flex flex-col items-center justify-center text-center overflow-hidden shadow-xl">
          {/* Starburst Effect CSS */}
          <div className="absolute inset-0 flex items-center justify-center opacity-20 pointer-events-none">
            <Star className="w-72 h-72 text-red-500 animate-spin-slow" />
          </div>

          <h2 className="text-4xl font-bold text-red-600 font-serif leading-none mb-3 transform -rotate-2 drop-shadow-md">
            A GRANDE COMPRA
            <br />
            DO MÊS
          </h2>
          <div className="bg-red-600 text-white px-3 py-1 text-sm font-bold mb-4 transform rotate-1 shadow-sm border border-black">
            PAGAMOS À VISTA
          </div>
          <p className="font-serif text-black font-bold mb-4 text-lg">
            GRANDES LOTES + MELHOR PREÇO DO MERCADO
          </p>
          <RetroButton
            variant="flat-3d"
            className="font-bold text-red-700 border-red-900"
            onClick={() => onNavigate('cotacao')}
          >
            Solicitar Cotação
          </RetroButton>
        </div>
      </div>

      <div className="mt-auto border-t border-gray-400 pt-2 text-center">
        <p className="text-xs font-serif text-gray-600 italic">
          Copyright © 1997 Banco da Sucata Inc. Todos os direitos reservados.
        </p>
      </div>
    </div>
  )
}
